import { Redirect } from "expo-router";

const Home = () => {
  return <Redirect href="/overview" />;
};

export default Home;
